import {Component, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {ApirequestService} from '../../../../services/apirequest/apirequest.service';
import {ApiurlsService} from '../../../../services/api-urls/apiurls.service';
import {UtilityService} from '../../../../services/utilities/utilities.services';
import {Router} from '@angular/router';
import {ToastsManager} from 'ng2-toastr';
import {OrderPipe} from 'ngx-order-pipe';
import {transition, trigger, useAnimation} from '@angular/animations';
import {fadeInDown} from 'ng-animate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';

@Component({
  selector: 'hybse-admin-listaffiliate',
  templateUrl: './listaffiliate.component.html',
  styleUrls: ['./listaffiliate.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ]
})
export class ListaffiliateComponent implements OnInit {
  public showLoader: boolean = true;
  public affiliateList: any = [];
  public paginatorList: any = [];
  public paginatorCount: number;
  fadeInDown: any;
  public errorMessage: string = null;
  public listTitle = 'All Affiliates';
  public count: number;
  public limit: number = 50;
  public offset: number = 0;
  public filterType: number;
  private modalRef: BsModalRef;
  private modalConfig = {
    backdrop: false,
    ignoreBackdropClick: true
  };
  private modalData: object;
  private objectKeys = Object.keys;

  // sorting
  reverse = false;
  order = 'createdat';
  sortedCollection: any = [];

  constructor(public _api: ApirequestService,
              public _urls: ApiurlsService,
              public _utils: UtilityService,
              public router: Router,
              public toastr: ToastsManager, vcs: ViewContainerRef,
              public _modalSrv: BsModalService,
              private orderPipe: OrderPipe) {
    this.toastr.setRootViewContainerRef(vcs);
  }

  getAffiliateStats(template: TemplateRef<any>, idAffiliate) {
    this.showLoader = true;
    const data = {
      idAffiliate: idAffiliate
    };

    this._api.fetchApiData(this._urls.affiliateReport, data).subscribe(
      (res: any) => {
        const response = res.data;
        const errRes = res.error;

        if (response) {
          this.modalData = response;
        } else {
          this.errorMessage = errRes['Error Description'];
        }
      },
      error => {
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        this.modalRef = this._modalSrv.show(template, this.modalConfig);
      }
    );
  }

  getAffiliateList() {
    const data = {
      offset: this.offset,
      limit: this.limit
    };

    this.affiliateList = [];

    this._api.fetchApiData(this._urls.affiliateListUrl, data).subscribe(
      (res: any) => {
        const response = res.data;
        const errRes = res.error;

        if (response) {
          this.affiliateList = response.affilifateList;
          this.count = response.count;
        } else {
          this.errorMessage = errRes['Error Description'];
        }
      },
      error => {
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    if (value === 'createdat') {
      this.showLoader = true;
      this.reverse ? this.filterType = 1 : this.filterType = 2;
      this.getAffiliateList();
    }
    this.order = value;
  }

  pagination(e) {
    this.offset = (e.pageIndex * 50);
    this.getAffiliateList();
  }

  ngOnInit() {
    this.getAffiliateList();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/affiliate/listaffiliate/listaffiliate.component.ts